import { ActionTypeEnum } from 'store/Actions'
import { SupportedLanguagesEnum } from 'types/Language'

export const setLanguageAction = (languageCode: SupportedLanguagesEnum) => ({
  type: ActionTypeEnum.SET_LANGUAGE_CODE,
  payload: languageCode,
})
